var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-2cbc7d5a"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "modalscrollable" };
var _hoisted_2 = { class: "m-b-15" };
var _hoisted_3 = {
    for: "Nome",
    class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_4 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_5 = { class: "m-b-15" };
var _hoisted_6 = {
    for: "Cognome",
    class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_7 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_8 = { class: "m-b-15" };
var _hoisted_9 = {
    for: "codefiscale",
    class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_10 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_11 = { class: "sm:col-span-2" };
var _hoisted_12 = {
    for: "citta",
    class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
    style: { "display": "inline-block" }
};
var _hoisted_13 = {
    role: "status",
    style: { "display": "inline-block", "margin-left": "2%" }
};
var _hoisted_14 = ["aria-hidden"];
var _hoisted_15 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("path", {
    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
    fill: "currentColor"
}, null, -1); });
var _hoisted_16 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("path", {
    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
    fill: "currentFill"
}, null, -1); });
var _hoisted_17 = [
    _hoisted_15,
    _hoisted_16
];
var _hoisted_18 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "sr-only" }, "Loading...", -1); });
var _hoisted_19 = { class: "m-b-15" };
var _hoisted_20 = { class: "relative" };
var _hoisted_21 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", {
    style: { "position": "absolute" },
    class: "inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
}, [
    /*#__PURE__*/ _createElementVNode("svg", {
        "aria-hidden": "true",
        class: "w-5 h-5 text-gray-500 dark:text-gray-400",
        fill: "currentColor",
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        id: "search"
    }, [
        /*#__PURE__*/ _createElementVNode("path", { d: "M448.3 424.7L335 311.3c20.8-26 33.3-59.1 33.3-95.1 0-84.1-68.1-152.2-152-152.2-84 0-152 68.2-152 152.2s68.1 152.2 152 152.2c36.2 0 69.4-12.7 95.5-33.8L425 448l23.3-23.3zM120.1 312.6c-25.7-25.7-39.8-59.9-39.8-96.3s14.2-70.6 39.8-96.3 59.9-40 96.2-40c36.3 0 70.5 14.2 96.2 39.9s39.8 59.9 39.8 96.3-14.2 70.6-39.8 96.3c-25.7 25.7-59.9 39.9-96.2 39.9-36.3.1-70.5-14.1-96.2-39.8z" })
    ])
], -1); });
var _hoisted_22 = ["placeholder"];
var _hoisted_23 = ["selected", "value"];
var _hoisted_24 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_25 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_26 = { class: "m-b-15" };
var _hoisted_27 = {
    for: "data_di_nascita",
    class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_28 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_29 = { class: "flex items-center" };
var _hoisted_30 = { role: "status" };
var _hoisted_31 = ["aria-hidden"];
var _hoisted_32 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("path", {
    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
    fill: "currentColor"
}, null, -1); });
var _hoisted_33 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("path", {
    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
    fill: "currentFill"
}, null, -1); });
var _hoisted_34 = [
    _hoisted_32,
    _hoisted_33
];
var _hoisted_35 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("span", { class: "sr-only" }, "Loading...", -1); });
var _hoisted_36 = {
    for: "statomatrimoniale",
    class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_37 = { class: "m-b-15" };
var _hoisted_38 = ["aria-readonly"];
var _hoisted_39 = ["selected", "value"];
var _hoisted_40 = { class: "m-b-15" };
var _hoisted_41 = {
    for: "sesso",
    class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
};
var _hoisted_42 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("option", {
    selected: "",
    hidden: ""
}, null, -1); });
var _hoisted_43 = { value: "female" };
var _hoisted_44 = { value: "male" };
import { onMounted, ref, computed, reactive } from 'vue';
import { initFlowbite } from 'flowbite';
import { storeToRefs } from 'pinia';
import AlertModal from "@/components/AlertModalFeedback.vue";
import debounce from '@/utils/debounce';
import { getGeoLocation } from "@/../../EshJSLib/services/geoService";
import { patientStore } from '@/store/patient';
import { getStatiMatrimoniali } from "../../../../EshJSLib/services/EshLOV";
import ErrorModal from '@/views/Components/ErrorModal.vue';
import { Modal } from "flowbite-vue";
import pazienteModalHeader from "@/views/schedaPaziente/pazienteModalHeader.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'pazienteBaseEdit',
    emits: ['cancel'],
    setup: function (__props, _a) {
        var _this = this;
        var emit = _a.emit;
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var extension = ref('');
        var cittaSearch = ref(false);
        var isOpenNas = ref(false);
        var isOpen = ref(false);
        var currentCityQueryNas = ref('');
        var cityList = ref([]);
        var pazienteModalTitle = ref("Aggiorna Informazioni anagrafiche");
        var mandatoryFields = ['paziente_nome', 'paziente_cognome', 'paziente_codfiscale', ['user', 'contact_detail', 'comune_nascita'], 'paziente_nascita', 'paziente_sesso'];
        var statiOptionList = ref([]);
        var statovisible = ref(false);
        var errors = ref([]);
        var errorMessage = "Questo campo è obbligatorio!";
        var errorMessageCF = "Codice Fiscale non valido!";
        var alertModal = ref(null);
        var showLoading = ref(false);
        onMounted(function () {
            patient.value.status = "update";
            initFlowbite();
            getStatiMatrimoniali().then(function (value) {
                statiOptionList.value = value;
                statovisible.value = true;
            });
            var index = patient.value.paziente_nascita.indexOf('T');
            if (index >= 0) {
                extension.value = patient.value.paziente_nascita.substring(index, patient.value.paziente_nascita.length);
                patient.value.paziente_nascita = patient.value.paziente_nascita.substring(0, index);
            }
        });
        var formattedDate = computed(function () {
            var date = new Date(patient.value.paziente_nascita);
            var day = date.getDate().toString().padStart(2, '0');
            var month = (date.getMonth() + 1).toString().padStart(2, '0');
            var year = date.getFullYear().toString();
            return "".concat(day, "/").concat(month, "/").concat(year);
        });
        function validateFields() {
            errors.value = [];
            for (var _i = 0, mandatoryFields_1 = mandatoryFields; _i < mandatoryFields_1.length; _i++) {
                var field = mandatoryFields_1[_i];
                if (field == 'paziente_codfiscale') {
                    errors.value.push(patient.value[field].length < 16 ? errorMessageCF : '');
                }
                else {
                    var value = typeof field == 'string' ? patient.value[field] : patient.value.user.contact_detail.comune_nascita;
                    errors.value.push(!value ? errorMessage : '');
                }
            }
            errors.value.push(currentCityQueryNas.value != patient.value.user.contact_detail.comune_nascita && currentCityQueryNas.value != "" ?
                'Seleziona una delle città' : '');
            console.log(errors);
            return errors.value.filter(function (err) { return err != ''; }).length == 0;
        }
        function updateValue() {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var userInput;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!validateFields()) {
                                return [2 /*return*/, false];
                            }
                            patient.value.paziente_nascita = patient.value.paziente_nascita + extension.value;
                            patient.value.status = "update";
                            localStorage.setItem('patient', JSON.stringify(patient.value));
                            return [4 /*yield*/, ((_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Salvare le modifiche ?", true))];
                        case 1:
                            userInput = _b.sent();
                            if (userInput) {
                                showLoading.value = true;
                                store.saveSchedaPaziente()
                                    .then(function () {
                                    var _a;
                                    showLoading.value = false;
                                    (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Salvato con successo! ", false).then(function () { return cancelmodal(); });
                                    store.refreshScheda(store.patient.id_paziente);
                                })
                                    .catch(function (res) {
                                    var _a;
                                    showLoading.value = false;
                                    (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
                                    store.refreshScheda(store.patient.id_paziente);
                                });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        function cancelmodal() {
            store.refreshScheda(patient.value.id_paziente);
            emit('cancel');
        }
        var isShowModal = reactive({
            dateError: false,
            alert: false,
        });
        function validateDate() {
            if (new Date(patient.value.paziente_nascita) >
                new Date()) {
                errors.value[4] = 'La data inserita non è valida!';
                patient.value.paziente_nascita = new Date().toISOString().split('T')[0];
                return;
            }
            errors.value[4] = '';
        }
        var closeErrorModal = function () {
            isShowModal.dateError = false;
        };
        function switchVisNas(e) {
            isOpenNas.value = false;
            if (e.target == null) {
                return;
            }
            currentCityQueryNas.value = e.target.value;
        }
        var checkCurrentTownNas = debounce(function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cittaSearch.value = true;
                        isOpen.value = false;
                        return [4 /*yield*/, getGeoLocation(currentCityQueryNas.value)];
                    case 1:
                        response = _a.sent();
                        cityList.value = response;
                        isOpenNas.value = true;
                        cittaSearch.value = false;
                        return [2 /*return*/];
                }
            });
        }); }, 700);
        return function (_ctx, _cache) {
            var _component_LoadingComponent = _resolveComponent("LoadingComponent");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Modal), {
                    onClose: _cache[11] || (_cache[11] = function ($event) { return (cancelmodal()); })
                }, {
                    header: _withCtx(function () { return [
                        _createVNode(pazienteModalHeader, {
                            title: _ctx.$t(_unref(pazienteModalTitle))
                        }, null, 8, ["title"])
                    ]; }),
                    body: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Nome')), 1),
                                _withDirectives(_createElementVNode("input", {
                                    class: _normalizeClass([{ 'border-red-500': _unref(errors)[0] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((_unref(patient).paziente_nome) = $event); }),
                                    type: "text",
                                    id: "nome",
                                    required: ""
                                }, null, 2), [
                                    [_vModelText, _unref(patient).paziente_nome]
                                ]),
                                _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(errors)[0]), 1)
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('Cognome')), 1),
                                _withDirectives(_createElementVNode("input", {
                                    class: _normalizeClass([{ 'border-red-500': _unref(errors)[1] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((_unref(patient).paziente_cognome) = $event); }),
                                    type: "text",
                                    id: "cognome",
                                    required: ""
                                }, null, 2), [
                                    [_vModelText, _unref(patient).paziente_cognome]
                                ]),
                                _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(errors)[1]), 1)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('Codice Fiscale')), 1),
                                _withDirectives(_createElementVNode("input", {
                                    class: _normalizeClass([{ 'border-red-500': _unref(errors)[2] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((_unref(patient).paziente_codfiscale) = $event); }),
                                    type: "text",
                                    id: "codefiscale",
                                    required: ""
                                }, null, 2), [
                                    [_vModelText, _unref(patient).paziente_codfiscale]
                                ]),
                                _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(errors)[2]), 1)
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("Città di nascita ")), 1),
                                _withDirectives(_createElementVNode("div", _hoisted_13, [
                                    (_openBlock(), _createElementBlock("svg", {
                                        "aria-hidden": !_unref(cittaSearch),
                                        class: "w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
                                        viewBox: "0 0 100 101",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                    }, _hoisted_17, 8, _hoisted_14)),
                                    _hoisted_18
                                ], 512), [
                                    [_vShow, _unref(cittaSearch)]
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                        _hoisted_21,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            id: "citta",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return (_isRef(currentCityQueryNas) ? (currentCityQueryNas).value = $event : currentCityQueryNas = $event); }),
                                            onKeyup: _cache[4] || (_cache[4] =
                                                //@ts-ignore
                                                function () {
                                                    var args = [];
                                                    for (var _i = 0; _i < arguments.length; _i++) {
                                                        args[_i] = arguments[_i];
                                                    }
                                                    return (_unref(checkCurrentTownNas) && _unref(checkCurrentTownNas).apply(void 0, args));
                                                }),
                                            onClick: _cache[5] || (_cache[5] = function ($event) {
                                                _isRef(isOpenNas) //@ts-ignore
                                                    ? isOpenNas.value = true : isOpenNas = true;
                                                _isRef(isOpen) //@ts-ignore
                                                    ? isOpen.value = false : isOpen = false;
                                            }),
                                            class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                            placeholder: _unref(patient).user.contact_detail.comune_nascita
                                        }, null, 40, _hoisted_22), [
                                            [_vModelText, _unref(currentCityQueryNas)]
                                        ])
                                    ]),
                                    _withDirectives(_createElementVNode("select", {
                                        id: "cittaSearch",
                                        onChange: _cache[6] || (_cache[6] = function ($event) { return (switchVisNas($event)); }),
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((_unref(patient).user.contact_detail.comune_nascita) = $event); }),
                                        size: "10",
                                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cityList), function (item) {
                                            return (_openBlock(), _createElementBlock("option", {
                                                class: _normalizeClass({ 'border-red-500': _unref(errors)[3] }),
                                                selected: item.city,
                                                key: item.city,
                                                value: item.city
                                            }, _toDisplayString(item.city), 11, _hoisted_23));
                                        }), 128))
                                    ], 544), [
                                        [_vShow, _unref(isOpenNas) === true],
                                        [_vModelSelect, _unref(patient).user.contact_detail.comune_nascita]
                                    ]),
                                    _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(errors)[3]), 1),
                                    _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(errors)[3] == "" ? _unref(errors)[6] : ''), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('Data di nascita')), 1),
                                _withDirectives(_createElementVNode("input", {
                                    class: _normalizeClass([{ 'border-red-500': _unref(errors)[4] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"]),
                                    onChange: validateDate,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) { return ((_unref(patient).paziente_nascita) = $event); }),
                                    type: "date",
                                    id: "data"
                                }, null, 34), [
                                    [_vModelText, _unref(patient).paziente_nascita]
                                ]),
                                _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(errors)[4]), 1)
                            ]),
                            _createElementVNode("li", _hoisted_29, [
                                _withDirectives(_createElementVNode("div", _hoisted_30, [
                                    (_openBlock(), _createElementBlock("svg", {
                                        "aria-hidden": statovisible.value,
                                        class: "w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
                                        viewBox: "0 0 100 101",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                    }, _hoisted_34, 8, _hoisted_31)),
                                    _hoisted_35
                                ], 512), [
                                    [_vShow, !statovisible.value]
                                ]),
                                _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('Stato Civile')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                                _withDirectives(_createElementVNode("select", {
                                    id: "statoMatr",
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) { return ((_unref(patient).id_stato_matrimoniale) = $event); }),
                                    "aria-readonly": statovisible.value,
                                    name: "statomatrimoniale",
                                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statiOptionList.value, function (stato) {
                                        return (_openBlock(), _createElementBlock("option", {
                                            selected: _unref(patient).id_stato_matrimoniale != null && stato.id_stato_matrimoniale === _unref(patient).id_stato_matrimoniale,
                                            key: stato.id_stato_matrimoniale,
                                            value: stato.id_stato_matrimoniale
                                        }, _toDisplayString(stato.stato_matrimoniale_nome), 9, _hoisted_39));
                                    }), 128))
                                ], 8, _hoisted_38), [
                                    [_vModelSelect, _unref(patient).id_stato_matrimoniale]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t('Sesso')), 1),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) { return ((_unref(patient).paziente_sesso) = $event); }),
                                    id: "sesso",
                                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                }, [
                                    _hoisted_42,
                                    _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.$t('female')), 1),
                                    _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.$t('male')), 1)
                                ], 512), [
                                    [_vModelSelect, _unref(patient).paziente_sesso]
                                ])
                            ])
                        ])
                    ]; }),
                    footer: _withCtx(function () { return [
                        _createElementVNode("button", {
                            id: "submitAnagrafica",
                            onClick: updateValue,
                            class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        }, _toDisplayString(_ctx.$t('Salva')), 1)
                    ]; }),
                    _: 1
                }),
                _createVNode(AlertModal, {
                    ref_key: "alertModal",
                    ref: alertModal
                }, null, 512),
                (showLoading.value)
                    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                    : _createCommentVNode("", true),
                _createVNode(ErrorModal, {
                    isShown: isShowModal.dateError === true,
                    errorMessage: _ctx.$t('validDate'),
                    onClose: closeErrorModal
                }, null, 8, ["isShown", "errorMessage"])
            ], 64));
        };
    }
});
